import type { BuildingFormInput } from "web_myplann/Portfolio/Forms/BuildingShared/buildingFormSchema";

export const BUILDING_FORM_DEFAULT_VALUES: BuildingFormInput = {
	location: "",
	locationMunicipality: "",
	locationZipCode: "",
	usableArea: null,
	floorArea: null,
	disposition: null,
	buildingMaterial: null,
	numberOfFloors: null,
	interiorValue: null,
	purchaseDate: null,
	description: "",
	terrace: false,
	loggia: false,
	balcony: false,
	garage: false,
	cellar: false,
	elevator: false,
	barrierFree: false,
	swimmingPool: false,
	forInvestments: false,
};
